import * as req from 'api/actions';
import * as c from './constant';

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionList = (
  payload = { module_type: 'NOV' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const getSettings = (card_type, callback) =>
  req.item(c.GET_SETTINGS, `/api/v1/administrators/ohp_settings`, callback, {
    card_type,
  });

export const updatedHealthStatus = (id, payload, callback) =>
  req.update(
    c.UPDATE_TEST_STATUS,
    `api/v1/administrators/occupational_health_permits/${id}`,
    payload,
    callback
  );

export const checkOr = (payload, callback) =>
  req.list(
    c.OR_CHECK,
    `api/v1/administrators/transaction_histories/nov/check_or`,
    payload,
    callback
  );